import { Component } from '@angular/core';
import { HttpHeaders, HttpClient, HttpResponse } from '@angular/common/http';
import { DataLayerBaseComponent } from './data-layer-base.component';
import { MapService } from './map.service';
import { DataLayerService } from './data-layer.service';
import { ConfigService } from './config.service';
import { UserMessageService } from './user-message.service';

declare var L;

/*
 * data-layer-wms defines a class to display wms floodplain data.
 *
 * Within the configuration file, WMS floodplain layers can be included:
 * "overlayLayers": [
 * 		{"id": "floodLayer", "label": "FEMA Floodplain",
 * 			"url": "https://hazards.fema.gov/gis/nfhl/services/public/NFHLWMS/MapServer/WMSServer",
 *			"class": "data-layer-wms",
 * 			"legendUrl": "https://hazards.fema.gov/gis/nfhl/services/public/NFHLWMS/MapServer/WmsServer?request=GetLegendGraphic&version=1.3.0&format=image/png&layer=4", "refresh": true },
 * ...
 * ]
			<div [ngClass]={doNotCreate:!active} style="padding-left: 25px"><img src={{legendUrl}} width="200"></div>
 */

@Component({
	selector: 'data-layer-wms',
	template: `
		<div class="checkboxDiv"><label class="overlay-layer"><input type="checkbox" (click)="menuControlSelected($event)">{{htmlElementLabel}}</label>
		<app-single-legend [active]=active [legendUrl]=legendUrl></app-single-legend>
		</div>
		`,
	styleUrls: ['app.component.css']
})
export class DataLayerWMSComponent extends DataLayerBaseComponent {
	http: HttpClient;
	layers = '4';
	format = 'image/png';
	version = '1.3.0';
	transparent = true;

	constructor(
		mapService: MapService,
		dataLayerService: DataLayerService,
		configService: ConfigService,
		userMessageService: UserMessageService,
		http: HttpClient) {
		super(mapService, dataLayerService, configService, userMessageService);
		this.http = http;
	}

	menuControlSelected (event): void {
		if ( event.target.checked ) {
			this.activateLayer();
		} else {
			this.deactivateLayer();
		}

	}

	setData ( someData: any ) {
        super.setData(someData);
        
		if ( someData.hasOwnProperty('layers')) {
			this.layers = someData.layers;
        }
		if ( someData.hasOwnProperty('format')) {
			this.format = someData.format;
        }
		if ( someData.hasOwnProperty('transparent')) {
			this.transparent = someData.transparent;
        }
		if ( someData.hasOwnProperty('version')) {
			this.version = someData.version;
        }

	}

	// refreshLayer first checks to see if the layer is active.  If so, activateLayer is called.
	refreshLayer() {
		if ( this.active === true ) {
			this.activateLayer();
		}
	}

	// First check whether the information has been read.
	// Display the markers on the map and set the layer to active.
	activateLayer () {
		console.log('Activating ' + this.id + ' layer.');
		if ( this.mapLayer != null ) {
			this.mapService.map.removeLayer(this.mapLayer);
		}
		if ( this.value == null || this.refresh === true ) {
			// once the data file has been read, drawMarkers is automatically called because an observer has been established
			this.parseDataFile();
		}

		let nowDate = Date.now();
		this.mapLayer = L.tileLayer.wms( this.value,
			{ layers: this.layers, transparent: this.transparent, version: this.version, format: this.format, v: nowDate }).addTo(this.mapService.map).bringToFront();
			// { layers: '4,20,24', transparent: true, format: 'image/png' }).addTo(this.mapService.map).bringToFront();
		this.mapLayer.setOpacity(.4);


		// activate legend as well
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (true);
		}

		this.active = true;

	}

	deactivateLayer() {
		console.log('Deactivating ' + this.id + ' layer.');
		if ( this.active === true ) {
			this.mapService.map.removeLayer(this.mapLayer);
			this.active = false;
		}
		const legendDisplay = this.mapService.getDataLayerLegendDisplay(this.id);
		if ( legendDisplay != null ) {
			legendDisplay['source'].next (false);
		}
	}

	parseDataFile () {
		console.log('In data-layer-wms.parseDataFile.');
		if ( this.url.startsWith('http')) {
			this.value = this.url;
		} else {
			this.value = this.configService.baseDir + this.url + '?nocache=' + (new Date()).getTime();
		}
	}

}
